<template src="./Index.html"></template>

<script>
import { showAlert } from "@/utils/helpers";
import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";

export default {
  //props: {
  //  itemId: {
  //    type: Number,
  //    required: true,
  //  },
  //},  
  model: {
    prop: "employee",
  },
  props: ["employee"],
  created() {
    this.$store.dispatch("lookups/getSpecialties");

    //this.$store
    //  .dispatch("employeeCourses/getForEdit", this.itemId)
    //  .then((res) => {
    //    this.employee = res;
    //  })
    //  .catch(() => { });
    this.HubConnect();
  },
  computed: {
    specialties() {
      return this.$store.state.lookups.specialties;
    },

    courseTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.CourseTypes
      );
    },
    uploadTypes() {
      return [
        { value: 1, label: "عبر المسح الضوئي" },
        { value: 2, label: "تحميل المرفق من الجهاز" }
      ]
    },
  },
  data() {
    return {
      connection: "",
      index: null,
      actionFlag: false,
      employeeCourses: [],
      headers: [
        {
          text: "اسم الدورة",
          value: "courseName",
          sortable: false,
          align: "start",
        },
        {
          text: "التخصص",
          value: "specialty",
          sortable: false,
          align: "start",
        },

        {
          text: "المتكفل بالدورة",
          value: "courseType",
          sortable: false,
          align: "start",
        },
        {
          text: "تاريخ الدورة",
          value: "courseDate",
          sortable: false,
          align: "start",
        },
        {
          text: "مصدر  الدورة",
          value: "source",
          sortable: false,
          align: "start",
        },
        //{
        //    text: "الوثيقة المرفقة",
        //    value: "fileName",
        //    sortable: false,
        //    align: "start",
        //},
        {
          text: "الإجراءات",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      employeeObj: { details: [] },
      employeeCourse: {
        courseAttachment: null,
        fileName: null,
        courseDate: null,
        byScanner: null,
      },
    };
  },
  // mounted: function () {
  //   this.connection.start();
  //   this.connection.on("ReceiveMessage", (fileName) => {
  //     console.log(fileName);
  //     this.employeeCourse.fileName = fileName;
  //   });
  //   this.connection.stop();
  // },

  methods: {
    ChangeUploadTypes() {
      this.employeeCourse.attachmentFile = null;
      this.employeeCourse.fileName = null;
    },
    addInfo() {
      let specialtyIndex = this.specialties.findIndex(
        (x) => x.value == this.employeeCourse.specialtyId
      );
      let courseTypeIndex = this.courseTypes.findIndex(
        (x) => x.value == this.employeeCourse.courseTypeId
      );

      if (
        this.employeeCourse.courseAttachment != null &&
        this.employeeCourse.byScanner == 2 &&
        this.employeeCourse.courseAttachment.type != "application/pdf" &&
        this.employeeCourse.courseAttachment.type != "image/jpeg" &&
        this.employeeCourse.courseAttachment.type != "image/jpg" &&
        this.employeeCourse.courseAttachment.type != "image/png"
      ) {
        showAlert("نوع المستند غير مدعوم يمكن رفع مستند pdf و صور فقط");
        return false;
      }
      this.employeeObj.details.push({
        courseName: this.employeeCourse.courseName,
        specialtyId: this.employeeCourse.specialtyId,
        courseTypeId: this.employeeCourse.courseTypeId,
        source: this.employeeCourse.source,
        specialty: this.specialties[specialtyIndex].label,
        courseType: this.courseTypes[courseTypeIndex].label,
        courseDate: this.employeeCourse.courseDate,
        courseAttachment: this.employeeCourse.courseAttachment,
        fileName: this.employeeCourse.fileName,
        byScanner: this.employeeCourse.byScanner,
      });
      (this.employeeCourse = {
        courseDetailsId: 0,
        courseAttachment: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();

    },
    getInfoToEdit(index) {
      this.index = index;
      this.employeeCourse = this.employeeObj.details[index];
      this.actionFlag = true;
    },
    removeInfo(index) {
      this.employeeObj.details.splice(index, 1);
    },
    editInfo() {
      let specialtyIndex = this.specialties.findIndex(
        (x) => x.value == this.employeeCourse.specialtyId
      );
      let courseTypeIndex = this.courseTypes.findIndex(
        (x) => x.value == this.employeeCourse.courseTypeId
      );

      //this.employeeCourse.fileName = this.employeeCourse.file.name;
      (this.employeeCourse.specialty = this.specialties[specialtyIndex].label),
        (this.employeeCourse.courseType =
          this.courseTypes[courseTypeIndex].label),
        this.employeeObj.details.splice(this.index, 1, this.employeeCourse);
      (this.employeeCourse = {
        courseDetailsId: 0,
        courseAttachment: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();
      this.actionFlag = false;

    },
    confirm() {
      let payload = {
        employeeId: this.employee.employeeId,
        items: this.employeeObj.details,
      };

      this.$store
        .dispatch("employeeCourses/edit", { id: this.employee.employeeCourseId, payload: payload })
        .then(() => {
          this.$emit("nextStep");
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 15);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.connection.stop();

      this.$emit("back");
    },
    download(item) {
      window.open(
        `/api/employeeCourses/${item.courseDetailsId}/attachment`,
        "_blank"
      );
    },
    cancel() {
      this.$emit("nextStep");
    },
    scann() {
      var fileN = null;
      var type = this.$attachmentTypes.CourseFile;
      console.log(type);
      var p = "DisableScanner331://" + 1 + "-" + type;
      console.log(p);
      window.location.href = p;
      this.connection.on("ReceiveMessage", (fileName) => {
        console.log(fileName);
        fileN = fileName;
        this.employeeCourse.fileName = fileName;
        console.log(this.employeeCourse.fileName);

      });
      this.employeeCourse.fileName = fileN;
    },
    HubConnect() {
      this.connection = new HubConnectionBuilder()
        .withUrl("/ScanHub")
        .configureLogging(LogLevel.Information)
        .build();
      this.connection.start().catch(function (err) {
        return console.error(err.toSting());
      });
    },
  },
};
</script>